import { QueryFunctionContext, useInfiniteQuery } from 'react-query'
import flatten from 'lodash/flatten'
import toast from 'react-hot-toast'
import { SortingRule } from 'react-table'

import offerService from '../services/offerService'
import { placePerPage } from '../utils/config'
import { useParamsToObj } from './useParamsToObj'
import { Offer, OffersFilter } from '../types/offers'
import { useUser } from './useUser'
import { BuzzlUsersError } from '../types/buzzl-user'

export function useOffers(orderBy?: SortingRule<Offer>[]) {
  const user = useUser()
  const { counter, ...urlParams } = useParamsToObj<OffersFilter>([
    'locations',
    'type',
    'cost',
    'nbClaimed',
    'customers',
    'search',
  ])

  return useInfiniteQuery(
    ['offers', urlParams, orderBy],
    (context: QueryFunctionContext) => {
      return offerService.getAllWithFilter(
        {
          first: placePerPage,
          skip: context.pageParam || 0,
          ...(orderBy && orderBy.length > 0
            ? { orderBy: `${orderBy[0].id}_${orderBy[0].desc ? 'DESC' : 'ASC'}` }
            : { orderBy: 'createdAt_DESC' }),
          ...(user.data?.customerUser?.customer?.id && {
            where: {
              customer: {
                id: user.data?.customerUser?.customer?.id,
              },
            },
          }),
        },
        urlParams
      )
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < placePerPage) return false
        return flatten(allPages).length
      },
      onError: (e) => {
        const error = e as BuzzlUsersError
        error.response.errors.map((er) =>
          toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
        )
      },
    }
  )
}
